module.exports = global["jQuery"] = require("-!/contests/assets/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 3
// module chunks = 85